var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"leagues-camps-signup"},[_c('h1',{staticClass:"title"},[_vm._v("Select a League (or Camp)")]),_c('signup-list',{attrs:{"season":_vm.season}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }